module.exports = __webpack_public_path__ + "img/icon_device3.fe780404.png";